import {Injectable} from '@angular/core';
import {CodeDesignation} from '../models/codeDesignation.model';
import {CodeDesignationCodeClient} from '../models/codeDesignationCodeClient.model';

@Injectable({providedIn: 'root'})
export class FormaterService {

	/**
	 * Formater pour le composant autocomplete, permet d'afficher le code - designation dans les résultats
	 * @param codeDesignation un résultat de la recherche autocomplete (code + designation)
	 */
	basicFormater(codeDesignation: CodeDesignation): string {
		if (codeDesignation) {
			return codeDesignation.code + ' - ' + codeDesignation.designation;
		}
		return '';
	}

	/**
	 * Formater spécfique pour les autocompletes magasin, permet d'afficher le code client - designation dans les résultats
	 * @param codeDesignationCodeClient un résultat de la recherche autocomplete (code client + designation)
	 */
	magasinAutocompleteFormater(codeDesignationCodeClient: CodeDesignationCodeClient): string {
		if (codeDesignationCodeClient) {
			return codeDesignationCodeClient.codeClient + ' - ' + codeDesignationCodeClient.designation;
		}
		return '';
	}

	/**
	 * Formater pour le composant autocomplete, permet d'afficher uniquement la designation dans les résultats
	 * @param codeDesignation un résultat de la recherche autocomplete (designation)
	 */
	basicFormaterDesignation(codeDesignation: CodeDesignation): string {
		if (codeDesignation) {
			return codeDesignation.designation;
		}
		return '';
	}
}
